import styled from "styled-components";

export const Main = styled.div<{ $isNoMinimize: boolean }>`
   position: relative;
   display: flex;
   align-items: center;
   flex-direction: column;
   justify-content: center;
   width: ${({ $isNoMinimize }) => $isNoMinimize ? '300px' : '150px'};
   padding: ${({ $isNoMinimize }) => $isNoMinimize ? '7.5px' : '0'};
   // transition: ${({ $isNoMinimize }) => $isNoMinimize ? 'all .3s linear' : 'none'};

   .btn1 svg {
      margin-right: 7.5px;
   }
   .select {
      width: 100%;
      white-space: nowrap;
      h4 { width: 95px; }
   }
   .textInput {
      margin-top: 10px;
      h4 { width: 117px; }
   }
   .annotations {
      position: absolute;
      // margin-top: -70px;
      display: flex;
      top: calc(100% + 23px + 21px);
      flex-direction: column;
      justify-content: center;
      min-width: 500px;

      &.noImage {
         width: auto;

         > div {
            height: auto;

            .container {
               text-align: center;
               padding: 15px 30px;
               white-space: nowrap;

               span {
                  opacity: 0.8;
               }
               .canvas-container {
                  display: none;
               }
            }
         }
      }
      &::before {
         content: '';
         position: absolute;
         top: -23px;
         left: calc(50% - 0.5px);
         width: 2px;
         height: 23px;
         background-color: #b1b1b7;
         z-index: 99;
      }
      .title {
         position: relative;
         display: flex;
         justify-content: space-between;
         align-items: center;
         background-color: #cee5fd;
         padding: 5px 7.5px;
         height: 30px;
         font-size: 16px;
         font-weight: 400;
         border: 1px solid rgb(220, 220, 220);
         border-radius: 10px 10px 0 0;

         svg {
            font-size: 19px;
            cursor: pointer;
            
            &:hover {
               color: #F05454;
            }
         }
      }
      > div {
         display: flex;
         flex-direction: column;
         padding: 15px;
         background-color: #fff;
         border: 1px solid rgb(220, 220, 220);
         border-top: none;
         border-radius: 0 0 10px 10px;
         background-color: #fff;
         // height: 700px;

         .top {
            display: flex;
            min-height: 35px;
            height: 35px;

            > input {
               margin-right: 15px;
               border-radius: 5px;
               width: 200px;
               font-size: 16px;
               padding: 0 15px;
               background-color: #F6F6F6;
               border: 1px dashed rgb(200, 200, 200);
            }
         }
      }
      .upload {
         position: relative;
         display: flex;
         align-items: center;
         justify-content: center;
         background-color: #F6F6F6;
         border: 2px dashed rgb(220, 220, 220);
         height: 100%;
         border-radius: 15px;
         transition: all .2s ease-in-out;
         width: 225px;
         cursor: pointer;
         margin-right: 15px;

         span { opacity: 0.4; }
         svg {
            font-size: 20px;
            margin-right: 7.5px;
            opacity: 0.2;
         }
         input {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
            z-index: 1;
         }
         &:hover {
            border-color: #1E272E;
         }
      }
      button {
         width: 50px;
         border-radius: 5px;
         border: none;
         font-size: 20px;
         background-color: #E02424;
         color: #fff;
         opacity: 0.8;
         transition: all .2s ease-in-out;
         margin-right: 7.5px;
         cursor: pointer;

         &.disabled {
            opacity: 0.5;
         }
         &:hover {
            opacity: 1;
         }
      }
      .container {
         border: 1px solid rgb(220, 220, 220);
         border-radius: 5px;
         margin-top: 15px;

         // .lower-canvas, .upper-canvas {
            /* width: 667px !important;
            height: 618px !important; */
            /* position: absolute;
               top: 0;
               left: 0;
               width: 100%;
               height: 100%; */
         // }
      }
   }
`;